module.exports = __webpack_public_path__ + "static/media/Industry-Bold.57b9533d.ttf";